'use strict';

// This is in the global scope to ensure it is accessible across the application
globalThis.lastActiveElementBeforeModal;

document.addEventListener('DOMContentLoaded', function() {
    // Add event listener to the "Read More" label on PDP for keyboard accessibility
    var label = document.querySelector('.read-more-label');
    if (label) {
        var updateAriaExpanded = function() {
            var inputId = label.getAttribute('for');
            var input = document.getElementById(inputId);
            if (input) {
                input.setAttribute('aria-expanded', input.checked ? 'true' : 'false');
                label.setAttribute('aria-expanded', input.checked ? 'true' : 'false');
            }
        };

        label.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                label.click();
                updateAriaExpanded();
            }
        });

        label.addEventListener('click', function() {
            // Delay to ensure input.checked is updated after click
            setTimeout(updateAriaExpanded, 0);
        });
    }

    // Hero Banners have an optional background video..
    // Add event listener to the "Toggle Video" button in hero media
    // to allow users to play/pause the video
    $('body').on('click', '.hero-media .toggle-video', function(event) {
        event.preventDefault();
        var $playerContainer = $(this).closest('.hero-media').find('.video-player');
        var playerId = $playerContainer.attr('id');
        var player = window.Players[playerId];

        if (player) {
            // these 2 configs unsure the video does not play automatically when user scrolls the page
            player.config.autoplay = false;
            player.config.modal = false;
            if ($playerContainer.hasClass('video-stopped')) {
                $playerContainer.removeClass('video-stopped');
                player.play();
                $(this).attr('aria-pressed', true).addClass('playing').attr('title', 'Pause');
            } else {
                player.pause();
                $playerContainer.addClass('video-stopped');
                $(this).attr('aria-pressed', false).removeClass('playing').attr('title', 'Play');
            }
        }
    });

    $('body').on('invalid', 'form', function(event) {
        $(this).find('.is-invalid').first().focus();
    });

    $('body').on('click', '[data-toggle="modal"], .wishlist-card-product-add, .wishlist-card-product-remove, .affirm-modal-trigger, .wishlist-toggle-product', function() {
        globalThis.lastActiveElementBeforeModal = document.activeElement;

        //console.log('lastActiveElementBeforeModal:', globalThis.lastActiveElementBeforeModal);

        // Set focus on the first focusable element in the modal
        setTimeout(function() {
            var modal = document.querySelector('.modal.show');
            if (modal) {
                var firstFocusable = modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                if (firstFocusable) {
                    firstFocusable.focus();
                }
            }
        }, 0);
    });

    $('.modal, body').on('hidden.bs.modal', function () {
        // Return focus to the last active element before the modal was opened
        //console.log('lastActiveElementBeforeModal:', globalThis.lastActiveElementBeforeModal);
        if (globalThis.lastActiveElementBeforeModal) {
            globalThis.lastActiveElementBeforeModal.focus();
        }
    });

});


